import { createRouter, createWebHistory } from 'vue-router'
// import { createRouter, createWebHashHistory } from 'vue-router'

import HomePage from "@/pages/HomePage/HomePage.vue"
import VenuePage from "@/pages/VenuePage/VenuePage.vue"
import KeynotePage from "@/pages/KeynotePage/KeynotePage.vue"
import AccommPage from "@/pages/AccommPage/AccommPage.vue"
import CommitteesPage from "@/pages/CommitteesPage/CommitteesPage.vue"
import OrganizerPage from "@/pages/OrganizerPage/OrganizerPage.vue"
import ContactPage from "@/pages/ContactPage/ContactPage.vue"
import ProgrammePage from "@/pages/ProgrammePage/ProgrammePage.vue"
import RegPage from "@/pages/RegPage/RegPage.vue"
import SubmissionGuidlines from "@/pages/SubmissionGuidlines/SubmissionGuidlines.vue"
import TopicsPage from "@/pages/TopicsPage/TopicsPage.vue"
import SponsorsPage from "@/pages/SponsorsPage/SponsorsPage.vue"
import AwardsPage from "@/pages/AwardsPage/AwardsPage.vue"
import WorkshopsPage from "@/pages/WorkshopPage/WorkshopsPage.vue"


const routes = [
    {
        path: "/",
        name:"home",
        component: HomePage,
        meta:{
            title:'AsiaCarto 2024 - Home'
        }
    },
    {
        path:"/keynote",
        name:"keynote",
        component: KeynotePage,
        meta:{
            title:'AsiaCarto 2024 - Keynote'
        }
    },
    {
        path:"/venue",
        name:"venue",
        component: VenuePage,
        meta:{
            title:'AsiaCarto 2024 - Venue'
        }
    },
    {
        path:"/accommodations",
        name:"accommodations",
        component: AccommPage,
        meta:{
            title:'AsiaCarto 2024 - Accommodations'
        }
    },
    {
        path:"/committees",
        name:"committees",
        component: CommitteesPage,
        meta:{
            title:'AsiaCarto 2024 - Committees'
        }
    },
    {
        path:"/organizer",
        name:"organizer",
        component: OrganizerPage,
        meta:{
            title:'AsiaCarto 2024 - Organizer'
        }
    },
    {
        path:"/contact",
        name:"contact",
        component: ContactPage,
        meta:{
            title:'AsiaCarto 2024 - Contact Us'
        }
    },
    {
        path:"/programme",
        name:"programme",
        component: ProgrammePage,
        meta:{
            title:'AsiaCarto 2024 - Programme'
        }
    },
    {
        path:"/registration",
        name:"registration",
        component: RegPage,
        meta:{
            title:'AsiaCarto 2024 - Registration'
        }
    },
    {
        path:"/sponsors",
        name:"sponsors",
        component: SponsorsPage,
        meta:{
            title:'AsiaCarto 2024 - Sponsors'
        }
    },
    {
        path:"/submission",
        name:"submission",
        component: SubmissionGuidlines,
        meta:{
            title:'AsiaCarto 2024 - Submission'
        }
    },
    {
        path:"/scopes_and_topics",
        name:"scopes_and_topics",
        component: TopicsPage,
        meta:{
            title:'AsiaCarto 2024 - Scopes & Topics'
        }
    },
    {
        path:"/awards",
        name:"awards",
        component: AwardsPage,
        meta:{
            title:'AsiaCarto 2024 - Awards'
        }
    },
    {
        path:"/workshops",
        name:"workshops",
        component: WorkshopsPage,
        meta:{
            title:'AsiaCarto 2024 - Workshops'
        }
    },
];

const router = createRouter({
    // history:createWebHashHistory(process.env.BASE_URL),
    history: createWebHistory(process.env.BASE_URL),
    base: "/2024/",
    // base:"/",
    routes,
});

router.beforeEach((to,from,next)=>{
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
})

export default router;